
import {Component} from 'vue-property-decorator';
import CreateCampaignForm from './create.vue';

@Component
export default class DuplicateCampaignForm extends CreateCampaignForm  {
  get modalTitle(){
    return this.t('Duplicate Campaign')
  }
  
  async load(id?: string) {
    const campaign = await this.campaignApi.get(this.campaign_id);

    campaign.name = campaign.name + ' (' + this.t('____x.copy') + ')';

    this.form = {
      ...campaign,
      trackingDomainId: campaign.trackingDomainId || '',
      trafficSource: campaign.trafficSource || {
        name: this.t('None'),
        id: ''
      },
      useTrafficLoss: campaign.trafficLossPercent !== null,
      usePostback: campaign.postbackPercent !== null,
      sendCustomConversionMode: campaign.sendCustomEventPostback?.mode || 'all',
      sendCustomConversionIds: campaign.sendCustomEventPostback?.ids || [],
      doNotSendNotSpecifiedConversions: campaign.sendCustomEventPostback?.doNotSendNotSpecifiedConversions || false
    };

    delete this.form.sendCustomEventPostback;
    
    this.oldHash = this.getCurrentHash();
  }
}
